import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const California = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>California Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Transfer Disclosure Statement (TDS) and Natural Hazard Disclosure
          Report required.
        </Text>

        <Text style={styles.listItem}>
          2. Natural Hazard Disclosure: Required in areas prone to natural
          disasters.
        </Text>

        <Text style={styles.listItem}>
          3. Transfer Disclosure Statement: Mandatory for most residential
          transactions.
        </Text>
      </View>

      <Text style={styles.subtitle}>
        Notice of Your 'Supplemental' Property Tax Bill
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          4. California property tax law requires the Assessor to revalue real
          property at the time the ownership of the property changes. Because of
          this law, you may receive one or two supplemental tax bills, depending
          on when your loan closes. The supplemental tax bills are not mailed to
          your lender. If you have arranged for your property tax payments to be
          paid through an impound account, the supplemental tax bills will not
          be paid by your lender. It is your responsibility to pay these
          supplemental bills directly to the Tax Collector. If you have any
          question concerning this matter, please call your local Tax
          Collector's Office.
        </Text>

        <Text style={styles.listItem}>
          5.{' '}
          <Text style={styles.underline}>Environmental Hazards Pamphlet</Text> –
          The buyer must receive a copy of this pamphlet.
        </Text>

        <Text style={styles.listItem}>
          6. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          7.{' '}
          <Text style={styles.underline}>
            Homeowner's Guide to Earthquake Safety
          </Text>{' '}
          – Required to be given to the buyer.
        </Text>

        <Text style={styles.listItem}>
          8. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Must accompany any purchase agreement about the sale of a property
          built before 1978.
        </Text>

        <Text style={styles.listItem}>
          9.{' '}
          <Text style={styles.underline}>
            Local Option Real Estate Transfer Statement
          </Text>{' '}
          – Only complete if the local jurisdiction requires it.
        </Text>

        <Text style={styles.listItem}>
          10. <Text style={styles.underline}>Megan's Law Disclosure</Text> – The
          buyer must be provided with the necessary information to search the
          surrounding area for sex offenders.
        </Text>

        <Text style={styles.listItem}>
          11.{' '}
          <Text style={styles.underline}>
            Natural Hazard Disclosure Statement
          </Text>{' '}
          – Seller must complete if the property is near any natural hazardous
          area.
        </Text>

        <Text style={styles.listItem}>
          12.{' '}
          <Text style={styles.underline}>
            Transfer Disclosure Statement (TDS)
          </Text>{' '}
          – Specific form required by law to be completed by the seller of a
          residential property.
        </Text>

        <Text style={styles.listItem}>
          13. <Text style={styles.underline}>Death on Premises Disclosure</Text>{' '}
          – A landlord must disclose to a prospective buyer if a death occurred
          in the unit less than three years before the buyer offers to purchase
          the unit. This does not apply if a previous occupant had HIV or died
          from AIDS-related complications.
        </Text>

        <Text style={styles.listItem}>
          14.{' '}
          <Text style={styles.underline}>
            Water Heater and Smoke Detector Compliance
          </Text>{' '}
          – To inform a buyer that the smoke detector and water heater comply
          with State law.
        </Text>

        <Text style={styles.listItem}>
          15.{' '}
          <Text style={styles.underline}>
            Water-Conserving Fixtures and Detector Notice
          </Text>{' '}
          – To inform the buyer about water-conserving fixtures that need to be
          replaced in construction and the status of carbon monoxide detectors.
        </Text>

        <Text style={styles.listItem}>
          16.{' '}
          <Text style={styles.underline}>
            Wood Destroying Pests and Organisms Inspection Report
          </Text>{' '}
          – To be given to the buyer after the inspection is complete.
        </Text>
      </View>
    </View>
  );
};

export default California;
